import { IApiGateway } from '@/modules/api/api.interface'

import { IRefusalReasonRepository } from './refusal-reason.repository.interface'
import { RefusalReasonsResponse } from './refusal-reason.types'

export class RefusalReasonRepository implements IRefusalReasonRepository {
  constructor(private api: IApiGateway) {}

  async getAll(): Promise<RefusalReasonsResponse[]> {
    return this.api.get<RefusalReasonsResponse[]>('refusal-reasons')
  }
}
